import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

declare global {
  interface Window {
    __GREENSPARKS_IS_RESIZE_OBSERVER_LOOP_ERROR__?: (message: unknown) => boolean;
  }
}

const isResizeObserverLoopError = (message: unknown) =>
  Boolean(window.__GREENSPARKS_IS_RESIZE_OBSERVER_LOOP_ERROR__?.(message)) ||
  (typeof message === "string" &&
    (message.includes("ResizeObserver loop completed with undelivered notifications") ||
      message.includes("ResizeObserver loop limit exceeded")));

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverLoopError(event.message || event.error?.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message =
    typeof reason === "string"
      ? reason
      : reason instanceof Error
        ? reason.message
        : reason?.message;
  if (isResizeObserverLoopError(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  //  <React.StrictMode>
  <App />
  //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
